export default {"src":"__ASTRO_ASSET_IMAGE__B9hyoRaK__","width":320,"height":662,"format":"png"}